import { useState, useEffect, useRef } from 'react';

const useMonitoringSocket = () => {
  const [connections, setConnections] = useState([]);
  const [isConnected, setIsConnected] = useState(false);
  const socket = useRef(null);

  useEffect(() => {
    const url = import.meta.env.VITE_MONITORING_WEBSOCKET_URL;
    if (!url) {
      console.error('VITE_MONITORING_WEBSOCKET_URL is not defined in .env');
      return undefined;
    }

    let alive = true;
    let reconnectDelay = 1000;
    let reconnectTimer = null;

    const connect = () => {
      if (!alive) return;
      socket.current = new WebSocket(url);

      socket.current.onopen = () => {
        console.log('Monitoring socket connected');
        reconnectDelay = 1000;
        setIsConnected(true);
      };

      socket.current.onmessage = (event) => {
        console.log('Received data from monitoring socket:', event.data);
        const data = JSON.parse(event.data);
        if (data.type === 'connection_update') {
          setConnections(data.connections);
        }
      };

      socket.current.onclose = (event) => {
        console.error('Monitoring socket closed unexpectedly:', event);
        setIsConnected(false);
        if (!alive) return;
        const delay = event.code === 4000 ? 100 : reconnectDelay;
        reconnectTimer = setTimeout(connect, delay);
        reconnectDelay = Math.min(reconnectDelay * 1.5, 30000);
      };

      socket.current.onerror = (error) => {
        console.error('Monitoring socket error:', error);
        setIsConnected(false);
      };
    };

    connect();

    return () => {
      alive = false;
      clearTimeout(reconnectTimer);
      if (socket.current) {
        socket.current.close(1000, 'monitoring cleanup');
      }
    };
  }, []);

  return { connections, isConnected };
};

export default useMonitoringSocket;
